import React, { useState } from "react";
import { connect } from "react-redux";
import { postComment, getComments } from "../../redux/actions/comAction";
import SendIcon from "@material-ui/icons/Send";
import { Input } from "antd";

const { TextArea } = Input;

const CommentBox = (props) => {
  const [commentText, setCommentText] = useState("");

  const body = {
    comment: commentText,
    blogPostId: props.postId,
    commenterId: props.user.id,
  };

  if (props.parentId) {
    body["parentCommentId"] = props.parentId;
  }

  return (
    <div className="comment-box">
      <div className="custom-textarea">
        <TextArea
          maxLength={1000}
          autoSize={{ minRows: 1, maxRows: 7 }}
          bordered={false}
          value={commentText}
          disabled={props.disabled}
          onChange={(e) => setCommentText(e.target.value)}
          onKeyPress={(e) => {
            if (!e.shiftKey && e.key === "Enter") {
              e.preventDefault();
              props.postComment(body).then(() => props.callChild());
              setCommentText("");
            }
          }}
          placeholder="Write a comment…"
          type="text"
        />
        <div className="icon">
          <SendIcon
            style={{
              fontSize: "1.2rem",
              color: "#2b6cb0",
            }}
            onClick={(e) => {
              e.preventDefault();
              props.postComment(body).then(() => {
                props.callChild();
                props.refetch();
              });
              setCommentText("");
            }}
          />
        </div>
      </div>
      <p>{commentText.length}/1000</p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.userData,
});

export default connect(mapStateToProps, { postComment, getComments })(
  CommentBox
);
